import React, {useContext, useEffect} from "react";
import {MaterialThemeProvider} from "./_metronic/layout";
import Routes from "./routes/Routes";
import {configContext} from './provider/ConfigProvider';

function App() {
  const config = useContext(configContext);

  useEffect(() => {
    document.title = `${config.client.page_title} ${(config.client.regionLogos || {}).region || ''}`;
  }, [config]);

  return (
    <MaterialThemeProvider>
      <Routes/>
    </MaterialThemeProvider>
  );
}
export default App;